import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import Navbar from "components/Navbars/Navbar.jsx";
import logoadministracion from "assets/img/menuPrincipal/administracion.png";
import logoEgreso from "assets/img/menuPrincipal/budget.png"
import logoReportes from "assets/img/menuPrincipal/statistics.png"
import logoalumnosAlt from "assets/img/menuPrincipal/language-learning.png"
import logoProspectos from "assets/img/menuPrincipal/add-user.png"
import logoColaboradores from "assets/img/menuPrincipal/team.png"
import logocertificado from "assets/img/menuPrincipal/certificado.png"
import logoGastos from "assets/img/menuPrincipal/receipt3.png"
import logoCatalogo from "assets/img/menuPrincipal/catalog.png"
import logoCalificaciones from "assets/img/menuPrincipal/exam.png"
import routesAdmin from "routes/routesAdministracion.js";
import routesCobranza from "routes/routesCobranza.js";
import routesReportes from "routes/routesReportes.js";
import routesGrupos from "routes/routesGrupos.js";
import routesAlumnos from "routes/routesAlumnos.js";
import routesCitas from "routes/routesCitas";
import routesProspectos from "routes/routesProspectos";
import routesColaboradores from "routes/routesColaboradores";
import routesCalificaciones from "routes/routesCalificaciones";
import routesGastos from "routes/routesGastos";
import routesCatalogos from "routes/routesCatalogos";
import routesInventario from "routes/routesInventario";
import routesAsistencia from "routes/routesAsistencia";
import routesToefl from "routes/routesToefl"

import logocalendario from "assets/img/menuPrincipal/calendario.png"
import logoIdiomas from "assets/img/menuPrincipal/idiomas.png"
import logoInventario from "assets/img/menuPrincipal/check-list.png"
import logoAsistencia from "assets/img/menuPrincipal/attendance.png"

import Snackbar from "components/Snackbar/Snackbar.jsx";
import CookiesU from 'universal-cookie';
const cookies = new CookiesU();

const style = {
  ...imagesStyles
};
const cookie = cookies.getAll()


class SectionCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      colorNotificacion: "success",
      mensaje: "",
      br: false,
      rutasAdministracion: [],
      rutasCobranza: [],
      rutasAlumnos: [],
      rutasReportes: [],
      rutasGrupos: [],
      rutasCitas: [],
      rutasProspectos: [],
      rutasColaboradores: [],
      rutasCalificaciones: [],
      rutasCalificaciones: [],
      rutasGasto: [],
      rutasCatalogos: [],
      rutasInventario: [],
      rutasAsistencia: [],
      rutasToefl: [],

      MostrarModalCargando: false
    };
  }

  componentWillMount() {
    this.setState({
      rutasAdministracion: routesAdmin,
      rutasCobranza: routesCobranza,
      rutasReportes: routesReportes,
      rutasGrupos: routesGrupos,
      rutasAlumnos: routesAlumnos,
      rutasCitas: routesCitas,
      rutasProspectos: routesProspectos,
      rutasColaboradores: routesColaboradores,
      rutasCalificaciones: routesCalificaciones,
      rutasGasto: routesGastos,
      rutasCatalogos: routesCatalogos,
      rutasInventario: routesInventario,
      rutasAsistencia: routesAsistencia,
      rutasToefl: routesToefl,
    });
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  componentDidMount() {
    if (cookies.get('mensaje') !== undefined) {
      this.setState({ mensaje: cookies.get('mensaje'), colorNotificacion: 'success', MostrarModalCargando: true })
      this.showNotification();
      cookies.remove('mensaje', { path: '' });
    } else {
      this.setState({ MostrarModalCargando: false });
    }
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      2000
    );
  }

  CambiarNavegacion = (ruta) => {
    window.location.href = '#/' + ruta;
  }


  render() {

    const { classes,  } = this.props;
    return (
      <div className="animated fadeIn">
        <Navbar
          routes={routesAdmin}
        />
        <Container>
          <div className="row mt-5">
            <div hidden={this.state.rutasAdministracion.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Administración</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={() => this.CambiarNavegacion("admin/Administracion")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoadministracion} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración general de la aplicación</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasCobranza.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Cobranza</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("cobranza/Cobranza")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoEgreso} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de cobranza</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasCitas.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Calendario de citas</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("Citas/Citas")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logocalendario} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Asignación y calendarización de citas</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasReportes.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Reportes</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("reportes/Reportes")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoReportes} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Generar reportes</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasProspectos.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Prospectos</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("prospectos/Prospectos")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoProspectos} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de prospectos</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasGrupos.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Grupos</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("grupos/Listado")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoIdiomas} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de Grupos</a></center>
                    </CardBody>
                  </a>
                </div>

              </Card>
            </div>
            <div hidden={this.state.rutasAlumnos.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Alumnos</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("alumnos/Alumnos")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoalumnosAlt} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de alumnos</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasColaboradores.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Colaboradores</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("Colaboradores/Colaboradores")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoColaboradores} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de colaboradores</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasCalificaciones.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Calificaciones</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("calificaciones/Calificaciones")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoCalificaciones} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Asignaciones de calificaciones</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasToefl.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Toefl</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("Toefl/Toefl")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logocertificado} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administracion de proceso de Toefl</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasGasto.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Gastos</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("gastos/Gastos")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoGastos} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de gastos</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasAsistencia.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Asistencia</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("asistencia/Asistencia")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoAsistencia} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de asistencias</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasInventario.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Inventario</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("inventario/Inventario")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoInventario} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de inventarios</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
            <div hidden={this.state.rutasCatalogos.length > 0 ? false : true} className='form-group col-lg-4 col-md-4 col-sm-6' >
              <Card className=" card-accent-success">
                <CardHeader className="text-white" style={{ backgroundColor: "#6D6A6B" }}>
                  <center><h5>Catálogos</h5></center>
                </CardHeader>
                <div class="hovereffect">
                  <a style={{ cursor: "pointer" }} onClick={()=>this.CambiarNavegacion("Catalogos/aulas")}>
                    <CardBody   >
                      <center><img class="img-responsive" width='25%' src={logoCatalogo} alt="" /></center>
                      <div class="overlay"></div>
                      <center className="mt-3"><a style={{ textDecoration: 'none' }}>Administración de catálogos</a></center>
                    </CardBody>
                  </a>
                </div>
              </Card>
            </div>
          </div>
        </Container>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
        {/* <Cargando
          show={this.state.MostrarModalCargando}
          Cuerpo="Cargando"
        /> */}
      </div >
    )
  }
}


export default withStyles(style)(SectionCards);